// eslint-disable-next-line no-unused-vars
import React from 'react';
import { bool, array, func } from 'prop-types';
import { Checkbox } from '@carbon/react';

import { FilterPropType } from 'Types/filters';
import FilterListComponent from 'Components/Filters/FilterListComponent';

const FilterGroupComponent = (
  { open, defaultChecked, filterValues, onToggle, onSearch, onChange, filter }
) => (
  <FilterListComponent
    cx={ open ? 'open' : 'closed' }
    onToggle={ onToggle }
    onSearch={ onSearch }
    showSearch={ filter.values.length > 10 }
    filterTitle={ filter.name }
  >
    <div className="options">
      { filterValues.map(({ value, slug, count, valueId }) => (
        <div className="filterItem" key={ `${ slug }_${ valueId }` }>
          <Checkbox
            id={ `${slug}_${valueId}` }
            name={ value }
            labelText={ value }
            checked={ defaultChecked(valueId) }
            onChange={ (_, { checked }) => onChange(filter.slug, [{ slug, value, id: valueId, valueId }])(checked) }
          />
          <span className="count">({ count })</span>
        </div>
      )) }
    </div>
  </FilterListComponent>
);

FilterGroupComponent.propTypes = {
  open: bool,
  defaultChecked: func,
  filterValues: array,
  onToggle: func,
  // activeFilter: oneOfType([object, arrayOf(FilterValuesPropType)]),
  onChange: func,
  onSearch: func,
  filter: FilterPropType
};

export default FilterGroupComponent;
